/* eslint-disable camelcase */
import { unstable_createMuiStrictModeTheme } from "@mui/material";
import {
  createTheme as createMuiTheme,
  StyledEngineProvider,
  Theme,
  ThemeProvider,
} from "@mui/material/styles";
import React, { ReactNode } from "react";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// ...
const createTheme =
  process.env.NODE_ENV === "production"
    ? createMuiTheme
    : unstable_createMuiStrictModeTheme;

interface Props {
  children: ReactNode;
}

let theme = createTheme({
  palette: {
    primary: {
      main: "#232f3e",
      dark: "#18202c",
      light: "#404854",
      semiLight: "#343f4d",
      contrastText: "rgba(255, 255, 255, 0.7)",
    },
    secondary: {
      main: "#4fc3f7",
    },
    background: {
      paper: "#eaeff1",
    },
  },
  mapDrawer: {
    width: 400,
    maxWidth: "80%",
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },

  shape: {
    borderRadius: 8,
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = {
  ...theme,
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.primary.dark,
        },
      },
    },
    // MuiStack: {
    //   defaultProps: { useFlexGap: true },
    // },
    // MuiStack: {
    //   defaultProps: {
    //     useFlexGap: true,
    //   },
    // },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.secondary.main,
          // root: {
          //   marginLeft: theme.spacing(1),
          // },
        },
      },
      defaultProps: {
        textColor: "inherit",
        indicatorColor: "primary",
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          margin: "0 16px",
          minWidth: 0,
          padding: 0,
          [theme.breakpoints.up("md")]: {
            padding: 0,
            minWidth: 0,
          },
        },
      },
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.primary.light,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          marginRight: 0,
          "& svg": {
            fontSize: 20,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*::-webkit-scrollbar": {
          width: 10,
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#d6dee1",
          borderRadius: 7,
          border: "3px solid transparent",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#a8bbbf",
        },
      },
    },
  },
};

const PaperBaseThemeProvider = ({ children }: Props): JSX.Element => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);
export default PaperBaseThemeProvider;
